<div class="h-full overflow-x-hidden flex flex-col" id="sidebar">
  <div class="logo"></div>
  <app-profile></app-profile>

  <div class="flex-1 overflow-y-auto">
    <ng-container *ngFor="let group of menuGroups; let i = index">
      <div class="menu-group" *ngIf="isGroupVisible(group)">
        <div class="group-header" (click)="toggleGroup(i)">
          <span class="group-title">{{ group.title }}</span>
          <lucide-icon
            name="chevron-down"
            [size]="12"
            class="text-white transition-transform duration-200"
            [class.rotate-180]="isGroupExpanded(i)"
          ></lucide-icon>
        </div>

        <ul *ngIf="isGroupExpanded(i)" @expandCollapse>
          <ng-container *ngFor="let item of group.items">
            <li *ngIf="isItemVisible(item)" class="cursor-pointer hover:bg-chathams-blue">
              <a class="flex items-center h-11" [routerLink]="'/dash/' + item.route" routerLinkActive="active">
                <div class="flex justify-center w-11">
                  <lucide-icon [name]="item.icon" [size]="16" class="text-white"></lucide-icon>
                </div>
                <div class="w-40 ml-2.5 text-sm text-white font-medium flex flex-row items-center">
                  {{ item.label }}
                  <div
                    *ngIf="item.hasNotification && (hasConsultasPendentes$ | async)"
                    class="w-2 h-2 rounded bg-status-warning ml-2"
                  ></div>
                </div>
              </a>
            </li>
          </ng-container>
        </ul>
      </div>
    </ng-container>
  </div>

  <div class="logout-container">
    <ul>
      <li class="cursor-pointer bg-cerise-red-600 hover:bg-cerise-red-700" (click)="logout()">
        <a class="flex items-center h-11">
          <div class="flex justify-center w-11">
            <lucide-icon name="log-out" [size]="16" class="text-white"></lucide-icon>
          </div>
          <div class="w-40 ml-2.5 text-sm text-white font-medium">Sair</div>
        </a>
      </li>
    </ul>
  </div>
</div>
